import { render, staticRenderFns } from "./CRecaptcha.vue?vue&type=template&id=b3a3f7e6&scoped=true"
import script from "./CRecaptcha.vue?vue&type=script&setup=true&lang=ts"
export * from "./CRecaptcha.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CRecaptcha.vue?vue&type=style&index=0&id=b3a3f7e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a3f7e6",
  null
  
)

export default component.exports